var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadmap4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 75,
    viewBox: "0 0 67 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2519 0.000815862C36.6211 0.0113232 35.0146 0.123218 33.4387 0.330434C52.0294 2.77491 66.3708 18.4846 66.3708 37.5C66.3708 56.5154 52.0294 72.2251 33.4387 74.6696C35.0146 74.8768 36.6211 74.9887 38.2519 74.9992C38.1675 74.9997 38.0831 75 37.9986 75C17.0126 75 0 58.2107 0 37.5C0 16.7893 17.0126 0 37.9986 0C38.0831 0 38.1675 0.000272234 38.2519 0.000815862Z",
    fill: "#FFB1B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmap4);
export default __webpack_public_path__ + "static/media/roadmap-4.65b1c117d23adcc1c66e5180d7620a10.svg";
export { ForwardRef as ReactComponent };